export default "__VITE_ASSET__D7CO9u9L__"